module.exports = __webpack_public_path__ + "img/w-personal-sales.67b1f4dc.svg";